<ng-container *ngIf="!item.hidden">
    <a
        *ngIf="shouldShowHrefItem()"
        [attr.href]="item.href"
        [attr.tabindex]="0"
        (click)="itemClick($event)"
        (keydown.enter)="itemClick($event)"
        rte="14j">
        <ng-container [ngTemplateOutlet]="iconTemplate"></ng-container>
    </a>
    <a
        *ngIf="shouldShowRouterItem()"
        [attr.tabindex]="0"
        [routerLink]="item.routerLink"
        routerLinkActive="active-menuitem-routerlink"
        [routerLinkActiveOptions]="{ exact: true }"
        (click)="onRouterLinkClick()"
        rte="14m">
        <ng-container [ngTemplateOutlet]="iconTemplate"></ng-container>
    </a>
    <a
        *ngIf="shouldShowCustomHandledItem()"
        href="#"
        [attr.tabindex]="0"
        (click)="itemClick($event)"
        (keydown.enter)="itemClick($event)"
        rte="14p">
        <ng-container [ngTemplateOutlet]="iconTemplate"></ng-container>
    </a>
    <a
        *ngIf="shouldShowLabelItem()"
        href="#"
        [attr.tabindex]="0"
        (click)="itemClick($event)"
        (keydown.enter)="itemClick($event)"
        rte="14s">
        <ng-container [ngTemplateOutlet]="iconTemplate"></ng-container>
        <i *ngIf="item.children?.length" class="pi pi-fw pi-angle-down submenu-icon" rte="14v"></i>
    </a>
    <ul
        *ngIf="item.children?.length && active"
        [@children]="
            (ultimaMain.isSlim || ultimaMain.isHorizontal) && root
                ? active
                    ? 'visible'
                    : 'hidden'
                : active
                ? 'visibleAnimated'
                : 'hiddenAnimated'
        "
        rte="14w">
        <ng-template ngFor let-child let-i="index" [ngForOf]="item.children">
            <li ultima-menu-item
             [item]="child"
             [index]="i"
             [parentKey]="key"
             (click)="onChildItemClick()"
             rte="14y"></li>
        </ng-template>
    </ul>

    <ng-template #iconTemplate>
        <span>
            <i *ngIf="item.miproIcon" class="mi" class="{{ item.classes }}">{{ item.miproIcon }}</i>
            <i *ngIf="!item.miproIcon && item.icon" class="material-icons">{{ item.icon }}</i>
            <span class="ultima-menu-item-text">{{ item.label }}</span>
        </span>
    </ng-template>
</ng-container>
